import React, { createContext, useState, useContext } from "react";

const VendorCodeContext = createContext();

export const VendorCodeProvider = ({ children }) => {
  const [selectedVendorCode, setSelectedVendorCode] = useState("");
  const [selectedVendorName, setSelectedVendorName] = useState("");
  const [vendorData, setVendorData] = useState(null);

  return (
    <VendorCodeContext.Provider
      value={{
        selectedVendorCode,
        setSelectedVendorCode,
        selectedVendorName,
        setSelectedVendorName,
        vendorData,
        setVendorData,
      }}
    >
      {children}
    </VendorCodeContext.Provider>
  );
};

export const useVendorCode = () => useContext(VendorCodeContext);
